import { MediumDesktop } from 'styles/MediaQueries';
import ClickThroughBottomSection from 'registration/lead/intro/clickThroughPageSections/ClickThroughBottomSection';
import ClickThroughTopSection from 'registration/lead/intro/clickThroughPageSections/ClickThroughTopSection';
import DynamicFooter from 'components/display/DynamicFooter';
import LeadIntroLogos from 'registration/lead/intro/LeadIntroLogos';
import React, { memo } from 'react';
import SiteHeader from '@opploans/site-header-component/SiteHeader';

const layoutStyles = {
  fontFamily: 'Arimo',
  display: 'flex',
  flexDirection: 'column'
};

const partnerLogoStyles = {
  display: 'flex',
  justifyContent: 'center',
  margin: '2rem 0 2.5rem',
  width: '100%',

  [MediumDesktop]: {
    margin: '2.5rem 0'
  }
};

const Footer = memo(DynamicFooter);

function Layout({ children }) {
  return (
    <>
      <SiteHeader />

      <div css={layoutStyles}>{children}</div>

      <div>
        <Footer />
      </div>
    </>
  );
}

function LeadIntroClickthroughPage({ partnerId, partnerName, showCobranding }) {
  return (
    <Layout
      partnerId={partnerId}
      partnerName={partnerName}
      showCobranding={showCobranding}
    >
      <div css={partnerLogoStyles}>
        <LeadIntroLogos
          partnerId={partnerId}
          partnerName={partnerName}
          showCobranding={showCobranding}
        />
      </div>

      <ClickThroughTopSection
        partnerId={partnerId}
        partnerName={partnerName}
        showCobranding={showCobranding}
      />

      <ClickThroughBottomSection />
    </Layout>
  );
}

export default LeadIntroClickthroughPage;
